import { FloorLampTorchiereVariantIcon } from './FloorLampTorchiereVariantIcon';

/**
 * author: Borre Haugen
 * id 85969E2D-500B-4565-8B80-A59FB6C8A73B
 * name floor-lamp-torchiere-variant
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp-torchiere-variant.svg
 * tags
 * - Home Automation 
 */
export const FloorLightTorchiereVariantIcon = FloorLampTorchiereVariantIcon;
export default FloorLightTorchiereVariantIcon